import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LibraryCategories } from '../../utils/constant';

const LibraryLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Function to handle navigation
  // const handleNavigation = useCallback(
  //   (path) => {
  //     navigate(path);
  //   },
  //   [navigate]
  // );

  return (
    <div className="h-[calc(100vh-68px)] overflow-hidden w-full text-white flex flex-col px-4 pt-4 pb-4">

      {/* ── Body: sidebar + main content ── */}
      <div className="flex gap-4 mx-0 md:mx-4 flex-1 min-h-0">

        {/* Sidebar — h1 lives here so it aligns with the search bar row in <main> */}
        <div className="w-[176px] hidden lg:flex flex-col gap-4 flex-shrink-0">
          {/* Heading — same height as search bar (38px) so they sit on one visual line */}
          <h1 className="text-lg md:text-xl font-semibold flex-shrink-0 leading-[38px]">Library</h1>

          {/* Nav card */}
          <nav className="bg-[#1e1f22] p-4 rounded-[10px] shadow-lg">
            <ul className="space-y-4 flex flex-col items-start w-full">
              {LibraryCategories.map(({ path, name, category, icon, disabled }, index) => (
                <li
                  key={index}
                  className={`w-full py-2 text-sm rounded-[50px] flex items-center justify-start gap-3 px-3 transition-all duration-300 ${
                    pathname === `${path}/${category}`
                      ? 'bg-[#31333A] text-white font-medium shadow-md cursor-pointer'
                      : 'text-[#D9D9D9] text-opacity-80 cursor-pointer hover:bg-[#31333A]'
                  }`}
                  onClick={() => navigate(`${path}/${category}`)}
                >
                  {icon ? (
                    <img src={icon} alt={`${name} icon`} className="h-4 w-4 object-contain" />
                  ) : null}
                  <span className="truncate">{name}</span>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Mobile: heading above content */}
        <div className="flex-1 min-h-0 overflow-hidden flex flex-col lg:hidden gap-3">
          <h1 className="text-lg font-semibold flex-shrink-0">Library</h1>
          <main className="flex-1 min-h-0 overflow-hidden">
            <Outlet />
          </main>
        </div>

        {/* Desktop main content */}
        <main className="hidden lg:flex flex-col flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default LibraryLayout;
